import React from 'react';
import styles from '../AiDialog.module.css';
import { ContextHint } from './ContextHint';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

export function PromptEditor({
  activePrompt,
  setActivePrompt,
  isLoading,
  errorMessage,
  onGenerate,
  generateButtonLabel = 'Generate',
  hasCategory,
  hasCuisine,
  productCategory,
  cuisineType,
}) {
  return (
    <div className={styles.promptRoot}>
      <div>
        {/* <label className={styles.promptLabel}>Prompt for AI</label> */}
        <textarea
          value={activePrompt}
          onChange={(e) => setActivePrompt(e.target.value)}
          className={styles.promptTextarea}
        />
      </div>

      <div className={styles.generateRow}>
        <ContextHint
          hasCategory={hasCategory}
          hasCuisine={hasCuisine}
          productCategory={productCategory}
          cuisineType={cuisineType}
        />
        <button
          type='button'
          onClick={onGenerate}
          disabled={isLoading}
          className={styles.generateBtn}
        >
          <AutoAwesomeIcon style={{ color: 'black', fontSize: '15px', marginRight: '5px' }} />
          {isLoading ? 'Generating…' : generateButtonLabel}
        </button>
      </div>

      {errorMessage && <span className={styles.promptError}>{errorMessage}</span>}
    </div>
  );
}
